import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import get from 'lodash/get';

import { refreshProfile as refreshProfileAction } from '../providers/customResources/profile/profileActions';

/**
 * Custom hook to get state of the profile stored in redux
 * Loading and error states are managed by redux and saga
 */
export const useProfile = () => {
  const dispatch = useDispatch();
  const profile = useSelector(state => get(state, 'profile.item'));
  const loading = useSelector(state => get(state, 'profile.loading'));
  const error = useSelector(state => get(state, 'profile.error'));

  /**
   * Force the refresh for the profile
   */
  const refreshProfile = useCallback(() => {
    dispatch(refreshProfileAction());
  }, [dispatch]);

  return {
    profile,
    loading,
    error,
    refreshProfile
  };
};
